import React, { useEffect, useState } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import Access_ControlActions from "../../Actions/Access_ControlActions";
import access_ControlStore from "../../Stores/Access_ControlStores";
import Access_ControlConstants from "../../Constants/Access_ControlConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import NotFoundCard from "../ReusableComponent/NotFoundCard";

export default function MultiPalPruefPlan({
  selectedItem,
  handelMultiplePruefPlaneDialogClose,
}) {
  const { localization } = useLanguageContext();
  const [tableData, setTableData] = useState(null);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  useEffect(() => {
    setGlobalSpinner(true);
    Access_ControlActions.GetAnlageLastInspections(selectedItem.id);
  }, []);

  useEffect(() => {
    function getAnlageLastInspectionSuccess() {
      const res = access_ControlStore.getAnlageLastInspectionDetails();
      if (res.length > 0) {
        setTableData(res);
      } else {
        setTableData(null);
      }
      setGlobalSpinner(false);
    }

    function getAnlageLastInspectionFailure() {
      const res = access_ControlStore.getAnlageLastInspectionDetails();
      setGlobalSpinner(false);
    }
    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_SUCCESS,
      getAnlageLastInspectionSuccess
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_FAILURE,
      getAnlageLastInspectionFailure
    );
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_SUCCESS,
        getAnlageLastInspectionSuccess
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_FAILURE,
        getAnlageLastInspectionFailure
      );
    };
  }, []);

  return (
    <div
      className="modal in dialogBox "
      id="MsgModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="MsgModalCenterTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered widthCustomize "
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addPruefPlan">
              {selectedItem.bezeichnung
                ? selectedItem.bezeichnung + " " + selectedItem.inventarnr
                : selectedItem.inventarnr}
            </h5>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addPruefPlanModalClose"
              onClick={handelMultiplePruefPlaneDialogClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body mulitplePruefTable">
            {tableData ? (
              <table className="table align-middle mb-5 table-striped table-hover table-sticky">
                <thead className="bg-light">
                  <tr>
                    <th>{localization.pruefName}</th>
                    <th>{localization.frequenz}</th>
                    <th>{localization.lastCheck}</th>
                    <th>{localization.nextCheck}</th>
                  </tr>
                </thead>

                <tbody>
                  {tableData.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{item.pruefPlanName}</td>
                        <td>{`${
                          item.frequency.toLowerCase() !== "a"
                            ? item.duration
                            : ""
                        } ${
                          item.frequency.toLowerCase() === "y"
                            ? localization.year
                            : item.frequency.toLowerCase() === "m"
                            ? localization.month
                            : item.frequency.toLowerCase() === "a"
                            ? localization.anytime
                            : localization.day
                        }`}</td>
                        <td>{item.lastCheck}</td>
                        <td>{item.nextCheck}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div className=" justify-content-center">
                <NotFoundCard title={localization.noRecordFound} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
